<style lang="less" scoped>
.h5-leapmptor-guide-container {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  background: #f8faff;
}

.list-title-div {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
  line-height: 22px;
  letter-spacing: 1px;
  margin: 15px 26px;
}

.guide-child-flex-div {
  display: flex;
  margin: 0 26px 15px 26px;
  height: 50px;
  background: #ffffff;
  box-shadow: 0px 0px 9px 3px rgba(186, 185, 185, 0.25);
  border-radius: 13px;
  overflow: hidden;
  padding: 16px;
}

.guide-child-title-div {
  flex: 1;
  font-size: 13px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
  line-height: 18px;
}

.guide-child-action-div {
  font-size: 13px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #54a3db;
  line-height: 18px;
}

.margin-top-32{
    margin-top: 32px;
}
</style>

<template>
  <div class="h5-leapmptor-guide-container">
    <div class="list-title-div">设备说明书</div>
    <div class="guide-list-div">
      <div
        class="guide-child-flex-div"
        v-for="eb in equipGuideList"
        :key="eb.title"
        @click="showFile(eb.url)"
      >
        <div class="guide-child-title-div">{{ eb.title }}</div>
        <div class="guide-child-action-div">下载</div>
      </div>
    </div>

    <div class="list-title-div margin-top-32">小程序操作说明书</div>
    <div class="guide-list-div">
      <div
        class="guide-child-flex-div"
        v-for="mb in miniGuideList"
        :key="mb.title"
        @click="showFile(mb.url)"
      >
        <div class="guide-child-title-div">{{ mb.title }}</div>
        <div class="guide-child-action-div">下载</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      equipGuideList: [
        { title: '充电桩说明书', url: 'https://img.cdn.wxzhida.cn/leapmotor/230912-%E9%9B%B6%E8%B7%91%E5%85%85%E7%94%B5%E6%A1%A9%E8%AF%B4%E6%98%8E%E4%B9%A6.pdf' },
      ],
      miniGuideList: [
        { title: '小程序使用说明书-蓝牙版本', url: 'https://img.cdn.wxzhida.cn/leapmotor/%E9%9B%B6%E8%B7%91LPCD%E5%B0%8F%E7%A8%8B%E5%BA%8F%E4%BD%BF%E7%94%A8%E8%AF%B4%E6%98%8E%E4%B9%A6v1.0.pdf' },
      ],
    }
  },
  methods: {
    init() {},
    showFile(fileUrl){
      window.open(fileUrl)
    }
  },
  mounted() {
    document.title = '说明书';
    this.init()
  },
}
</script>
